import React from "react";
import { Flex } from "@chakra-ui/react";
import { capitalize } from "lodash-es";
import { dbQueries, useQueryParams } from "duck";
import { Skeleton, Tag } from "./components";
import { useOptions } from "./duck";

interface TagsProps {
  withStatus?: boolean;
  withDoctors?: boolean;
  withProcedures?: boolean;
}

const Tags: React.FC<TagsProps> = ({
  withStatus = false,
  withProcedures = false,
  withDoctors = false
}) => {
  const [params, setParams] = useQueryParams();

  const procedures = useOptions(dbQueries.loadProcedures, "procedures");
  const doctors = useOptions(dbQueries.loadUsers, "doctors");

  if (!params.filter) {
    return null;
  }

  return (
    <>
      <Flex flexDirection="row" flexWrap="wrap" gap="12px">
        {withStatus &&
          params.filter?.status?.map((st: string) => (
            <Tag
              label={capitalize(st)}
              key={st}
              onClose={() => {
                setParams({
                  ...params,
                  filter: {
                    ...params.filter,
                    status: params.filter.status.filter(
                      (id: string) => id !== st
                    )
                  },
                  pagination: { page: 1 }
                });
              }}
            />
          ))}

        {withDoctors &&
          doctors.ids.map(docId => {
            const doctor = doctors.options.find(doc => doc._id === docId);

            return doctor ? (
              <Tag
                label={`${doctor?.firstName} ${doctor?.lastName}`}
                key={docId}
                onClose={() => {
                  setParams(
                    {
                      ...params,
                      filter: {
                        ...params.filter,
                        doctors: doctors.ids.filter(id => id !== docId)
                      },
                      pagination: { page: 1 }
                    },
                    { replace: true }
                  );
                }}
              />
            ) : (
              <Skeleton key={docId} />
            );
          })}

        {withProcedures &&
          procedures.ids.map(pr => {
            const procedure = procedures.options.find(el => el.name === pr);

            return procedure ? (
              <Tag
                label={procedure?.name}
                key={pr}
                onClose={() => {
                  setParams({
                    ...params,
                    filter: {
                      ...params.filter,
                      procedures: procedures.ids.filter(id => id !== pr)
                    },
                    pagination: { page: 1 }
                  });
                }}
              />
            ) : (
              <Skeleton key={pr} />
            );
          })}
      </Flex>
    </>
  );
};

export default Tags;
